import _get from 'lodash/get'

const BUSINESS_STATUSES = [
  {
    id: 'submissionStarted',
    name: 'Submission started',
  },
  {
    id: 'checkPending',
    name: 'Check Pending',
  },
  {
    id: 'checkStarted',
    name: 'Check Started',
  },
  {
    id: 'checkInProgress',
    name: 'Check in progress',
  },
  {
    id: 'checkOnHold',
    name: 'Check On hold',
  },
  {
    id: 'checkFailed',
    name: 'Check failed',
  },
  {
    id: 'addressPending',
    name: 'Address pending',
  },
  {
    id: 'bddPending',
    name: 'BDD pending',
  },
  {
    id: 'bddInProgress',
    name: 'BDD in progress',
  },

  {
    id: 'bddCompleted',
    name: 'BDD completed',
  },
  {
    id: 'bddRejected',
    name: 'BDD rejected',
  },
]
const BUSINESS_STATUSES_AS_OBJECT = {}
BUSINESS_STATUSES.forEach(row => {
  BUSINESS_STATUSES_AS_OBJECT[row.id] = row.id
})

class BusinessRecord {
  constructor (record) {
    this._record = record

    this.id = _get(record, 'id', 'new')

    this.createdAt = new Date(_get(record, 'createdAt'))
    this.updatedAt = new Date(_get(record, 'updatedAt'))
    this.status = _get(record, 'status', null)

    this.statusAsString = this.getStatusString(record)

    this.userId = _get(record, 'userId', '')
    this.businessName = _get(record, 'businessName', null)
    this.address = _get(record, 'address', null)
    this.cpkAddress = _get(record, 'cpkAddress', null)
    this.polygonCpkAddress = _get(record, 'polygonCpkAddress', null)
  }

  getStatusString (record) {
    const result = BUSINESS_STATUSES.find(r => r.id === record.status)

    return result ? result.name : record.status
  }
}

export {
  BUSINESS_STATUSES,
  BUSINESS_STATUSES_AS_OBJECT,
  BusinessRecord,
}
